import i18next from "../i18n";
import View from "./View";
class MainView extends View {
  _availabilityStatus = document.querySelector(".opening-state-js");
  _btnCategory = document.querySelectorAll(".product-category");
  // There are two delivery buttons (one for mobiles, and the other one for desktops)
  _btnDelivery = document.querySelectorAll(".service-button.delivery");
  _btnDetailsTime = document.querySelector(".details-time");
  // There are two pickup buttons (one for mobiles, and the other one for desktops)
  _btnPickup = document.querySelectorAll(".service-button.pickup");
  _categoryList = document.querySelector(".navigation-list");
  _data;
  _headerOfflineSection = document.querySelector(".header-offline-section");
  _itemFooter = document.querySelectorAll(".footer-item");
  // Left carousel arrow
  _leftArrow = document.querySelector(".floating-button-carousel.left");
  _navBar = document.querySelector(".navbar-category");
  _openingStateContainer = document.querySelector(".opening-state");
  // Right carousel arrow
  _rightArrow = document.querySelector(".floating-button-carousel.right");
  // Intersection observer constructor with threshold array
  _scrollOptions = {
    root: null,
    rootMargin: "0px",
    // eslint-disable-next-line no-magic-numbers
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  };
  // Create intersection observer by calling its constructor and passing it the callback function 'changeNav'
  _scrollObserver = new IntersectionObserver(
    this.changeNav.bind(this),
    this._scrollOptions,
  );
  _sectionProduct = document.querySelectorAll(".container-category-list");

  _tooltipContainerTime = document.querySelector(".tooltip-container-time");

  _tooltipTextTime = document.querySelector(".tooltiptext-time");

  // Clear the content of the elements
  _clear() {
    this._availabilityStatus.innerHTML = "";
  }

  // Adjust navbar padding based on category count
  adjustNavbarPadding() {
    // Safety check: ensure navbar exists
    if (!this._navBar) {
      return;
    }

    // Re-query to get current count (in case DOM changed)
    const categoryItems = this._navBar.querySelectorAll(".product-category");
    const categoryCount = categoryItems.length;

    const SINGLE_CATEGORY_CLASS = "navbar-category-single";
    const SINGLE_CATEGORY_COUNT = 1;

    // Apply special padding when exactly 1 category exists
    if (categoryCount === SINGLE_CATEGORY_COUNT) {
      this._navBar.classList.add(SINGLE_CATEGORY_CLASS);
    } else {
      this._navBar.classList.remove(SINGLE_CATEGORY_CLASS);
    }
  }

  // Callback function of the intersection observer
  changeNav(entries) {
    entries.forEach((entry) => {
      const { intersectionRatio, isIntersecting, target } = entry;

      // Represent the specified number of decimal places
      const DECIMAL_PLACES = 1;

      // Represents the threshold when the section is fully visible
      const FULL_THRESHOLD = 1;
      // Represents the threshold when the section is not fully visible
      const OFFSET_THRESHOLD = 0.1;

      // Calculate visible screen by subtracting nav list and sticky header heights
      const screenVisibleHeight =
        window.innerHeight -
        this._headerOfflineSection.offsetHeight -
        this._categoryList.offsetHeight;

      // Calculate callback threshold
      const thresholdChangeNav =
        screenVisibleHeight >= target.offsetHeight
          ? FULL_THRESHOLD
          : (
              screenVisibleHeight / target.offsetHeight -
              OFFSET_THRESHOLD
            ).toFixed(DECIMAL_PLACES);

      // Run callback function whenever the threshold is crossed
      if (isIntersecting && intersectionRatio >= thresholdChangeNav) {
        this._btnCategory.forEach((el) => {
          if (el.classList.contains("active")) {
            el.classList.remove("active");
          }
        });

        // Get id of the intersecting section
        const id = target.getAttribute("id");

        // Find matching link and add appropriate class
        const newLink = document.querySelector(`[data-ref="${id}"]`);
        if (newLink) {
          newLink.classList.add("active");

          // Get the position of the navbar category relative to the viewport
          const navRect = this._navBar.getBoundingClientRect();

          // Get the position of the active link button relative to the viewport
          const linkRect = newLink.getBoundingClientRect();

          // Calculate the offset of the link relative to the navbar
          const offsetLeft = linkRect.left - navRect.left;

          // Scroll horizontally to the link position
          this._navBar.scrollLeft += offsetLeft;
        }
      }
    });
  }

  // Add windows resize event to handle change in screen dimensions
  fireWindowSize() {
    const HEADER_OFFSET = 2;
    // Height of sticky header
    const headerHeight = this._headerOfflineSection.offsetHeight;

    // Set height of the sticky category header
    this._categoryList.style.setProperty(
      "--sticky-header",
      `${headerHeight - HEADER_OFFSET}px`,
    );
  }

  formatDeliveryTimes(deliveryTimes) {
    const SINGLE_TIMESLOT_LENGTH = 2;
    const FIRST_TIME_IN_ARRAY_INDEX = 0;
    const LAST_TIME_IN_ARRAY_INDEX = 1;

    // Case when deliveryTimes is a single time slot
    if (
      deliveryTimes.length === SINGLE_TIMESLOT_LENGTH &&
      typeof deliveryTimes[FIRST_TIME_IN_ARRAY_INDEX] === "string"
    ) {
      const openTime = deliveryTimes[FIRST_TIME_IN_ARRAY_INDEX];
      const closeTime = deliveryTimes[LAST_TIME_IN_ARRAY_INDEX];
      return `${i18next.t("status.open")} ${this.formatTimeRange(openTime, closeTime)}`;
    }

    // Sort the time ranges chronologically
    deliveryTimes.sort(
      (a, b) =>
        this.timeToMinutes(a[FIRST_TIME_IN_ARRAY_INDEX]) -
        this.timeToMinutes(b[FIRST_TIME_IN_ARRAY_INDEX]),
    );

    // Case when deliveryTimes is an array of time ranges
    const formattedTimes = deliveryTimes
      .map((range) =>
        this.formatTimeRange(
          range[FIRST_TIME_IN_ARRAY_INDEX],
          range[LAST_TIME_IN_ARRAY_INDEX],
        ),
      )
      .join(` ${i18next.t("conjunctions.and")} `);
    return `${i18next.t("status.open")} ${formattedTimes}`;
  }

  formatTimeRange(start, end) {
    const HOURINDEX = 0;
    const MINUTEINDEX = 1;

    const startHour = start.split(":")[HOURINDEX];
    const startMinute = start.split(":")[MINUTEINDEX];
    const endHour = end.split(":")[HOURINDEX];
    const endMinute = end.split(":")[MINUTEINDEX];

    return `${i18next.t("time.from")} ${parseInt(startHour, 10)}:${startMinute} ${i18next.t("time.to")} ${parseInt(
      endHour,
      10,
    )}:${endMinute}`;
  }

  // Event listeners for carousel button clicks
  handleCarouselBtnClick() {
    const LEFTMOST_POSITION = 0;
    this._rightArrow.addEventListener("click", () => {
      this.scrollToPosition.bind(this)(
        this._navBar.scrollWidth - this._navBar.clientWidth,
      );
    });

    this._leftArrow.addEventListener("click", () => {
      this.scrollToPosition(LEFTMOST_POSITION);
    });
  }

  // Event listeners for carousel button display
  handleCarouselBtnDisplay() {
    this._navBar.addEventListener("scroll", this.updateCarouselBtn.bind(this));
    window.addEventListener("resize", this.updateCarouselBtn.bind(this));
  }

  // Current date is located in this._data
  renderData(data, closingDays, deliveryTimes, timezone) {
    if (!data || !closingDays || !deliveryTimes) {
      return this.renderError();
    }
    this._data = this.getDateInTimezone(timezone, data);
    this._clear();

    // Get the current time
    const currentTime = this.getTimeFromDate(this._data);

    // Check if current date is a closing day
    if (this.isClosingDay(this._data, closingDays)) {
      // If the current date is a closing day
      this._availabilityStatus.textContent = i18next.t("status.closedNow");
      this._availabilityStatus.style.color = "var(--error-color)";

      // Get the name of the weekday
      const weekday = [
        i18next.t("days.sunday"),
        i18next.t("days.monday"),
        i18next.t("days.tuesday"),
        i18next.t("days.wednesday"),
        i18next.t("days.thursday"),
        i18next.t("days.friday"),
        i18next.t("days.saturday"),
      ];

      const day = weekday[this._data.getDay()];

      // // Get the name of the weekday based on the navigator's language
      // const day = this._data.toLocaleDateString(navigator.language, {
      //   Weekday: "long",
      // });

      // Generate delivery time in tooltip
      this._tooltipTextTime.innerHTML = `${i18next.t("time.notOpenOn")} ${day}`;
    } else {
      // If the current date is not a closing day

      // Return the day of the week (An integer, between 0 and 6)
      const dayValue = this._data.getDay();

      // Retrieve from the API delivery times for the specific day of the week
      const deliveryTimeValue = deliveryTimes[dayValue].map((time) => [
        time.startingHour,
        time.endingHour,
      ]);

      // Generate delivery time in tooltip
      this._tooltipTextTime.innerHTML =
        this.formatDeliveryTimes(deliveryTimeValue);

      // If current time falls within one of the time slots (delivery times)
      if (this.isTimeWithinAnySlot(currentTime, deliveryTimeValue)) {
        this._availabilityStatus.textContent = i18next.t("status.openNow");
        this._availabilityStatus.style.color = "var(--brand-main-color);";
      } else {
        // If current time doesn't fall within any time slot
        this._availabilityStatus.textContent = i18next.t("status.closedNow");
        this._availabilityStatus.style.color = "var(--error-color)";
      }
    }
    return true;
  }

  /* Update links in the navigation list based on scroll position (with intersection observer) */

  renderError(
    availabilityMessage = i18next.t("status.unknown"),
    message = i18next.t("status.restaurantUnavailable"),
  ) {
    this._clear();
    this._clearModalError();
    this._availabilityStatus.textContent = availabilityMessage;
    this._availabilityStatus.style.color = "var(--error-color)";
    this._errorContainer.textContent = message;
    this._tooltipTextTime.innerHTML = i18next.t("error.restaurantHours");
    this.openModalError();
  }

  // Call the function 'fireWindowSize' when the page has been resized or loaded
  resizeCategoryHeader() {
    window.addEventListener("resize", this.fireWindowSize.bind(this));
  }

  // Scroll to the maximum left or right position
  scrollToPosition(position) {
    this._navBar.scrollTo({
      behavior: "smooth",
      left: position,
    });
  }

  // Attach event listeners for hashchange and page load to the window
  scrollToSection() {
    ["hashchange", "load"].forEach((ev) =>
      window.addEventListener(ev, this.showSection.bind(this)),
    );

    this._btnCategory.forEach((el) => {
      el.onclick = this.showSection.bind(this);
    });
  }

  // Scroll to category section on navlink click
  showSection() {
    // Return the anchor part of the URL, including the hash sign
    let sectionId = window.location.hash;
    // Decode the URL-encoded characters
    sectionId = decodeURIComponent(sectionId);

    // Return navlink element
    const element = document.querySelector(`[href="${sectionId}"]`);

    if (element) {
      // Retun value of the data attribute
      const href = element.getAttribute("data-ref");

      // Return category section element
      const scrollToCategory = document.querySelector(`#${href}`);

      // Height of navbar section
      const navbarHeight = this._categoryList.scrollHeight;

      // Height of sticky header
      const headerHeight = this._headerOfflineSection.scrollHeight;

      // Get the position of the body element relative to the viewport
      const sectionRect = document.body.getBoundingClientRect();

      // Get the position of the active category relative to the viewport
      const categoryRect = scrollToCategory.getBoundingClientRect();

      // Calculate the offset of the active category relative to the body
      const offsetTop = categoryRect.top - sectionRect.top;

      // Set the number of pixels the body is scrolled to
      // For Chrome, Firefox, IE and Opera
      document.documentElement.scrollTop =
        offsetTop - (headerHeight + navbarHeight);
      // For Safari
      document.body.scrollTop = offsetTop - (headerHeight + navbarHeight);
    }
  }

  // Helper function to convert time to minutes for sorting
  timeToMinutes(time) {
    const MINUTES_IN_HOUR = 60;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * MINUTES_IN_HOUR + minutes;
  }

  // Interact with tooltip
  tooltipHandleTime() {
    const SHAKEDURATION = 5000;
    let hideTooltipTimeout;

    // Elements to add event listeners to
    const elements = [this._btnDetailsTime, this._tooltipContainerTime];

    // Show tooltip on hover
    this._openingStateContainer.onmouseover = (e) => {
      e.stopPropagation();
      this._tooltipTextTime.style.visibility = "visible";
      this._tooltipTextTime.style.opacity = "1";
      this._tooltipTextTime.style.pointerEvents = "auto";
    };

    // Show tooltip  on click
    elements.forEach((el) => {
      el.onclick = (e) => {
        // Clear any pending timeout
        clearTimeout(hideTooltipTimeout);

        e.stopPropagation();
        this._tooltipTextTime.style.visibility = "visible";
        this._tooltipTextTime.style.opacity = "1";
        this._tooltipTextTime.style.pointerEvents = "auto";

        // Hide tool tip after 5 seconds to ensure that it gets closed for mobile users
        hideTooltipTimeout = setTimeout(() => {
          this._tooltipTextTime.style.visibility = "hidden";
          this._tooltipTextTime.style.opacity = "0";
          this._tooltipTextTime.style.pointerEvents = "none";
        }, SHAKEDURATION);
      };
    });

    // Close tooltip on mouse out
    this._openingStateContainer.onmouseout = (e) => {
      e.stopPropagation();
      this._tooltipTextTime.style.visibility = "hidden";
      this._tooltipTextTime.style.opacity = "0";
      this._tooltipTextTime.style.pointerEvents = "none";
    };

    // Close tooltip when clicking outside of it
    document.addEventListener("click", (e) => {
      e.stopPropagation();
      // Check if the clicked element is not part of the tooltip text
      if (!e.target.closest(".tooltiptext")) {
        if (this._tooltipTextTime.style.visibility === "visible") {
          this._tooltipTextTime.style.visibility = "hidden";
          this._tooltipTextTime.style.opacity = "0";
          this._tooltipTextTime.style.pointerEvents = "none";
        }
      }
    });
  }

  // Update the visibility of the carousel arrows
  updateCarouselBtn() {
    const LEFTMOST_POSITION = 0;
    const maxScrollLeft = this._navBar.scrollWidth - this._navBar.clientWidth;

    if (this._navBar.scrollWidth > this._navBar.clientWidth) {
      // The nav bar is scrollable
      if (
        this._navBar.scrollLeft > LEFTMOST_POSITION &&
        this._navBar.scrollLeft < maxScrollLeft
      ) {
        // In the middle, show both arrows
        this._leftArrow.style.display = "inline-flex";
        this._rightArrow.style.display = "inline-flex";
      } else if (this._navBar.scrollLeft === LEFTMOST_POSITION) {
        // At the start, show only the right arrow
        this._leftArrow.style.display = "none";
        this._rightArrow.style.display = "inline-flex";
      } else if (this._navBar.scrollLeft === maxScrollLeft) {
        // At the end, show only the left arrow
        this._leftArrow.style.display = "inline-flex";
        this._rightArrow.style.display = "none";
      }
    } else {
      // The nav bar is not scrollable, hide both arrows
      this._leftArrow.style.display = "none";
      this._rightArrow.style.display = "none";
    }
  }

  updateDeliveryButton() {
    for (let i = 0; i < this._btnDelivery.length; i++) {
      if (!this._btnDelivery[i].classList.contains("toggle-active")) {
        this._btnDelivery[i].classList.add("toggle-active");
        this._btnPickup[i].classList.remove("toggle-active");
      }
    }
  }

  updatePickupButton() {
    for (let i = 0; i < this._btnPickup.length; i++) {
      if (!this._btnPickup[i].classList.contains("toggle-active")) {
        this._btnPickup[i].classList.add("toggle-active");
        this._btnDelivery[i].classList.remove("toggle-active");
      }
    }
  }

  // Watch target element whenever the target meets the threshold
  watchCategory() {
    this._sectionProduct.forEach((section) => {
      this._scrollObserver.observe(section);
    });
  }
}

export default new MainView();
